import { render, staticRenderFns } from "./CoTwoTransportationShootingForm.vue?vue&type=template&id=2593cbae&scoped=true&"
import script from "./CoTwoTransportationShootingForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportationShootingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593cbae",
  null
  
)

export default component.exports